import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {WidgetContactChooserValueV0Dto} from './models/widget-contact-chooser-value-v0.dto';
import {WContactChooserResponseV0Dto} from '@pt/widgets';
import {IoniconsOutline} from '@pt/pt-models';
import {WidgetUtils} from '../../widget.utils';

@Component({
  selector: 'pt-widget-contact-chooser-v0-row',
  template: `
    <tr *ngIf="show" class="contact-chooser-row">
      <td>
        <div class="td-contact-chooser">
          <ng-select
            appendTo="body"
            *ngIf="!loading"
            bindValue="uuid"
            bindLabel="label"
            container="body"
            [ngbTooltip]="currentTooltipCol1 | translate"
            class="ng-select--custom"
            [ngModel]="currentIdCol1"
            (ngModelChange)="changeValueCol1($event)"
          >
            <ng-option *ngFor="let option of col1Values" [value]="option?.uuid">
              <div style="white-space: pre-line;">
                {{ option?.label | translate }}
              </div>
            </ng-option>
          </ng-select>

          <pt-icon
            class="d-inline-flex text-warning ms-1"
            *ngIf="!isValidCol1"
            [key]="IconWarning"
            [ngbTooltip]="'WIDGET_WARNING.REQUIRED_VALUE' | translate"
          >
          </pt-icon>
        </div>
      </td>
      <td>
        <div class="td-contact-chooser">
          <ng-select
            appendTo="body"
            *ngIf="!loading"
            bindValue="uuid"
            bindLabel="label"
            class="ng-select--custom"
            container="body"
            [ngbTooltip]="currentTooltipCol2 | translate"
            [ngModel]="currentIdCol2"
            [disabled]="disabledCol2"
            (ngModelChange)="changeValueCol2($event)"
          >
            <ng-option *ngFor="let option of col2Values" [value]="option?.uuid">
              <div style="white-space: pre-line;">
                {{ option?.label | translate }}
              </div>
            </ng-option>
          </ng-select>
        </div>
      </td>
      <td>
        <div class="td-contact-chooser">
          <ng-select
            appendTo="body"
            *ngIf="!loading"
            bindValue="uuid"
            bindLabel="label"
            class="ng-select--custom"
            container="body"
            [ngbTooltip]="currentTooltipCol3 | translate"
            [ngModel]="currentIdCol3"
            [disabled]="disabledCol3"
            (ngModelChange)="changeValueCol3($event)"
          >
            <ng-option *ngFor="let option of col3Values" [value]="option?.uuid">
              <!--              <div class="item-select">-->
              <div style="white-space: pre-line;">
                {{ option?.label | translate }} {{ option?.label2 || '' }}
              </div>
              <!--                <pt-w-help *ngIf="option.help" [help]='option.help'></pt-w-help>-->
              <!--              </div>-->
            </ng-option>
          </ng-select>
        </div>
      </td>
      <td>
        <div class="td-contact-chooser" *ngIf="!loading">
          <input
            class="form-check-input"
            container="body"
            ngbTooltip="{{ 'TOOLTIP.USE_RESOURCE_EMAIL' | translate }}"
            style="margin:0 10px"
            type="checkbox"
            [(ngModel)]="useReferentEmail"
            (ngModelChange)="changeUseDefaultEmail($event, true)"
            [disabled]="disabledCol3"
          />
          <input
            type="text"
            *ngIf="useReferentEmail"
            class="form-control form-control-sm d-inline-flex custom-input "
            [readOnly]="true"
            [ngModel]="defaultEmail"
          />

          <input
            type="text"
            *ngIf="!useReferentEmail"
            class="form-control form-control-sm d-inline-flex custom-input "
            [disabled]="useReferentEmail"
            [(ngModel)]="currentIdCol4"
            (focusout)="changeValueCol4(currentIdCol4, true)"
            (ngModelChange)="changeValueCol4($event, false)"
          />
          <pt-icon
            class="d-inline-flex text-warning ms-1"
            *ngIf="isInvalidMail"
            [key]="IconWarning"
            container="body"
            [ngbTooltip]="
              emailOptional
                ? ('WIDGET_WARNING.INVALID_EMAIL' | translate)
                : ('WIDGET_WARNING.REQUIRED_MAIL' | translate)
            "
          >
          </pt-icon>
        </div>
      </td>
      <td class="td-contact-chooser latest-col">
        <pt-icon
          class="delete-btn cursor-pointer"
          [key]="IconClose"
          (click)="deleteRow.emit()"
        ></pt-icon>

        <!--        <button class='btn btn-sm btn-danger' (click)='deleteRow.emit()'>-->
        <!--          {{'BUTTON.REMOVE' | translate}}-->
        <!--        </button>-->
      </td>
    </tr>
  `,
  styles: [
    `
    .item-select{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: red;
      :is(div) {
        display: flex;
        white-space: nowrap;        /* Impedisce il ritorno a capo */
        overflow: hidden;           /* Nasconde il testo che va oltre il contenitore */
        text-overflow: ellipsis;
        flex-grow: 1;
      }
      :is(pt-w-help) {
        display: flex;
      }
    }
    .delete-btn {
      color: #a44545;
    }

    .delete-btn:hover {
      color: #aa0000;
    }

    .latest-col {
      max-width: 25px;
      min-width: 25px;
    }

    .td-contact-chooser {
      display: flex;
      align-items: center;
      height: 25px;
      justify-content: flex-start;
    }

    .contact-chooser-row {
      position: relative;
      max-width: 600px;
      padding: 0;
    }

    .contact-chooser-row td {
      max-width: 20%;
    }

    .custom-input {
      min-width: 120px;
      padding-top: 0;
      height: 24px;
      min-height: 24px;
    }

    .ng-select--custom {
      width: 100%;
      /*max-width: 120px;*/
      min-width: 120px;
      display: inline-flex;
    }
  `,
  ],
})
export class WidgetContactChooserV0RowComponent implements OnChanges {
  @Input() value: WidgetContactChooserValueV0Dto;
  @Input() col1: WContactChooserResponseV0Dto[];
  @Input() col2: WContactChooserResponseV0Dto[];
  @Input() col3: WContactChooserResponseV0Dto[];
  @Input() emailOptional = false;

  @Input() allValue: WidgetContactChooserValueV0Dto[];

  @Output() changeValue = new EventEmitter<WidgetContactChooserValueV0Dto>();
  @Output() deleteRow = new EventEmitter();

  loading = false;
  IconTrash = IoniconsOutline.trash;
  IconWarning = IoniconsOutline.warning;
  IconClose = IoniconsOutline.close;

  currentIdCol1: string;
  currentIdCol2: string;
  currentIdCol3: string;
  currentIdCol4: string;

  currentTooltipCol1: string;
  currentTooltipCol2: string;
  currentTooltipCol3: string;

  useReferentEmail: boolean;
  defaultEmail: string;

  disabledCol2: boolean;
  disabledCol3: boolean;

  col1Values: WContactChooserResponseV0Dto[];
  col2Values: WContactChooserResponseV0Dto[];
  col3Values: WContactChooserResponseV0Dto[];

  show: boolean;
  isInvalidMail: boolean;
  isValidCol1: boolean;
  isInvalidDefaultMail: boolean;

  lockedCol3: string[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.col1 || changes.col2 || changes.col3) {
      const selectedCol3 = this.col3.find((c) => c.uuid === this.value.col3);
      this.defaultEmail = selectedCol3?.email;
      this.resetRow(
        this.value?.col1,
        this.value?.col2,
        this.value?.col3,
        this.value?.col4,
        this.value?.useReferentEmail
      );
    }
    if (changes.allValue) {
      this.controlCol3();
    }
  }

  changeValueCol1($event: string) {
    if (this.currentIdCol1 !== $event) {
      this.resetRow(
        $event && $event !== 'null' ? $event : null,
        null,
        null,
        this.currentIdCol4,
        this.useReferentEmail
      );
      this.checkIsValidCol1();
      this.propagateChange();
    }
  }

  changeValueCol2($event: string) {
    if (this.currentIdCol2 !== $event) {
      this.resetRow(
        this.currentIdCol1,
        $event ? $event : null,
        null,
        this.currentIdCol4,
        this.useReferentEmail
      );
      this.propagateChange();
    }
    this.controlCol3();
  }

  changeValueCol3($event: string) {
    if (this.currentIdCol3 !== $event) {
      const defaultMail = this.col3.find((c) => c.uuid === $event);
      this.defaultEmail = defaultMail?.email;
      this.resetRow(
        this.currentIdCol1,
        this.currentIdCol2,
        $event ? $event : null,
        defaultMail?.email ? defaultMail?.email : this.currentIdCol4,
        this.useReferentEmail
      );
      this.propagateChange();
    }
  }

  changeValueCol4($event: string, propagate = false) {
    this.checkIsValidCol4();
    if (propagate) {
      this.propagateChange();
    }
  }

  changeUseDefaultEmail($event: boolean, propagate = false) {
    this.useReferentEmail = $event;
    this.checkIsValidDefaultEmail(this.useReferentEmail);
    if (propagate) {
      this.propagateChange();
    }
  }

  propagateChange() {
    this.currentIdCol4 = this.useReferentEmail
      ? this.defaultEmail
      : this.currentIdCol4;
    const out: WidgetContactChooserValueV0Dto = {
      col1: this.currentIdCol1,
      col2: this.currentIdCol2,
      col3: this.currentIdCol3,
      col4: this.currentIdCol4,
      useReferentEmail: this.useReferentEmail,
    };
    this.changeValue.emit(out);
  }

  private resetRow(
    col1: string | null,
    col2: string | null,
    col3: string | null,
    col4: string | null,
    useReferentEmail?: boolean
  ) {
    this.show = false;
    if (this.value) {
      this.currentIdCol1 = col1;
      this.currentIdCol2 = col2;
      this.currentIdCol3 = col3;
      this.currentIdCol4 = col4 ? col4 : '';
      this.currentTooltipCol1 = this.getTooltip(this.col1, col1, false);
      this.currentTooltipCol2 = this.getTooltip(this.col2, col2, false);
      this.currentTooltipCol3 = this.getTooltip(this.col3, col3, true);

      this.useReferentEmail = useReferentEmail;

      this.disabledCol2 =
        !this.currentIdCol1 ||
        this.currentIdCol1 === null ||
        this.currentIdCol1 === '' ||
        this.currentIdCol1 === 'null';
      this.disabledCol3 =
        !this.currentIdCol2 ||
        this.currentIdCol2 === null ||
        this.currentIdCol2 === '' ||
        this.currentIdCol2 === 'null';

      this.col1Values = this.col1;
      this.col2Values =
        this.currentIdCol1 && this.col2
          ? this.col2.filter(
              (c) =>
                c.filter === undefined ||
                c.filter === null ||
                c.filter === this.currentIdCol1
            )
          : this.col2;

      this.controlCol3();

      this.checkIsValidCol1();
      this.checkIsValidCol4();
      this.checkIsValidDefaultEmail(this.useReferentEmail);
    }
    this.show = true;
  }

  private checkIsValidCol1() {
    this.isValidCol1 = this.currentIdCol1?.length > 0;
  }

  private checkIsValidDefaultEmail(useReferentEmail: boolean) {
    if (useReferentEmail) {
      this.isInvalidDefaultMail = WidgetUtils.isInvalidMail(
        this.defaultEmail,
        this.emailOptional
      );
    } else {
      this.isInvalidDefaultMail = false;
    }
  }
  private checkIsValidCol4() {
    this.isInvalidMail = WidgetUtils.isInvalidMail(
      this.currentIdCol4,
      this.emailOptional
    );
  }

  private controlCol3() {
    this.lockedCol3 = [];
    this.col3Values =
      this.currentIdCol2 && this.col3
        ? this.col3.filter(
            (c) =>
              c.filter === null ||
              c.filter === undefined ||
              c.filter === this.currentIdCol2
          )
        : this.col3;

    if (this.allValue) {
      const f = this.allValue.filter(
        (f) =>
          f.col1 === this.currentIdCol1 &&
          f.col2 === this.currentIdCol2 &&
          f.col3 !== this.currentIdCol3
      );
      this.lockedCol3 = f.map((a) => a.col3);
    }
    this.col3Values = this.col3Values.filter(
      (f) => !this.lockedCol3.includes(f.uuid)
    ); //this.currentCol2 && this.col3 ? this.col3.filter((c) => c.filter === this.currentCol2 || c.filter === null) : this.col3;
  }

  private getTooltip(
    col: WContactChooserResponseV0Dto[],
    uuid: string,
    isCol3: boolean
  ): string {
    const value: WContactChooserResponseV0Dto | undefined = col.find(
      (c) => c.uuid === uuid
    );
    if (value) {
      if (isCol3) {
        return value.label + (value.label2 ? ' ' + value.label2 : '');
      }
      return value.label;
    }
    return undefined;
  }
}
